// import { data_index } from "./dataIndex";
const sample_data = [
  {
    theme: "にくりょうり",
    challengeWords: ["か あけ", " んかつ", "はんはー ", "や  り"],
    correctWords: ["からあけ", "とんかつ", "はんはーく", "やきとり"],
    lostChars: "らくとき",
    charsWithoutChip: "きくこさしすせそたちてとらるれろ",
    hintMessage: "お題、何かな？",
  },
];

export const sample = sample_data[0];
